/* ab-ritual.js (WS-ABOUT): scroll-scrubbed frame sequence for the About ritual. Vanilla, ~2 KB gz.
   Lazy-loads frames near the viewport, draws only while the section is on screen, holds each frame then cross-blends to the next.
   Reduced motion: adds .ab-rm (static figures, CSS). Mobile gets the 900 px frames. */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-ab-rit]').forEach(function (sec) {
    if (RM) { sec.classList.add('ab-rm'); return; }
    var cv = sec.querySelector('.ab-rit__cv'), track = sec.querySelector('.ab-rit__track'), stick = sec.querySelector('.ab-rit__stick');
    if (!cv || !cv.getContext) { sec.classList.add('ab-rm'); return; }
    var ctx = cv.getContext('2d'), n = +sec.getAttribute('data-n') || 6;
    var small = Math.min(innerWidth, screen.width || innerWidth) < 700;
    var urls = (cv.getAttribute(small ? 'data-m' : 'data-d') || '').split('|'), imgs = [], loaded = 0, started = false, active = false, tick = 0, W = 0, H = 0;
    var caps = [].slice.call(sec.querySelectorAll('.ab-rit__cap')), dots = [].slice.call(sec.querySelectorAll('.ab-rit__dots li')), cur = -1;
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, small ? 1.25 : 1.5), r = stick.getBoundingClientRect();
      W = Math.round(r.width * dpr); H = Math.round(r.height * dpr);
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    }
    function cover(im, a, z) {
      if (!im || !im.complete || !im.naturalWidth) return;
      var s = Math.max(W / im.naturalWidth, H / im.naturalHeight) * (z || 1), w = im.naturalWidth * s, h = im.naturalHeight * s;
      ctx.globalAlpha = a; ctx.drawImage(im, (W - w) / 2, (H - h) / 2, w, h);
    }
    function ease(t) { t = Math.max(0, Math.min(1, (t - .22) / .56)); return t * t * (3 - 2 * t); }
    function draw() {
      tick = 0; if (!loaded) return;
      var r = track.getBoundingClientRect(), span = track.offsetHeight - stick.offsetHeight, p = span > 0 ? Math.max(0, Math.min(1, -r.top / span)) : 0;
      var pos = p * (n - 1), i = Math.min(n - 2, Math.floor(pos)), f = pos - i, e = ease(f);
      ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, W, H);
      var z = 1.05 - .05 * p; cover(imgs[i], 1, z); cover(imgs[i + 1], e, z);
      ctx.globalAlpha = 1;
      var k = Math.max(0, Math.min(n - 1, Math.round(pos)));
      if (k !== cur) { cur = k; caps.forEach(function (c, j) { c.classList.toggle('is-on', j === k); }); dots.forEach(function (c, j) { c.classList.toggle('is-on', j === k); }); }
    }
    function req() { if (!tick && active) tick = requestAnimationFrame(draw); }
    function load() {
      if (started) return; started = true;
      urls.forEach(function (u, j) { var im = new Image(); im.decoding = 'async'; im.onload = function () { loaded++; if (loaded === 1 || loaded === n) { size(); if (loaded === n) sec.classList.add('is-ready'); req(); } }; im.src = u; imgs[j] = im; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) load(); }); }, { rootMargin: '900px 0px' }).observe(sec);
      new IntersectionObserver(function (es) { active = es[0].isIntersecting; if (active) { size(); req(); } }, { rootMargin: '100px 0px' }).observe(track);
    } else { load(); active = true; }
    addEventListener('scroll', req, { passive: true });
    addEventListener('resize', function () { size(); req(); });
  });
})();
